import React from 'react';
import { Badge, Button, SegmentedControl, Skeleton } from '../ui';
import { chapterLabel, sortChapters } from './examData';
import './ExamWidgets.css';

// Holat obyekti: { loading, error, data } (Students paneli courseStatuses ichida).

// "Imtihon topshirilgan boblar" chip'lari. Hozir faqat examed/chapters (id, title, order) —
// o'tdi/o'tmadi belgisi yo'q. Backend bob natijalari endpoint'ini qo'shganda
// (backend-requests.md, 1-band) holat belgisi shu komponentga qo'shiladi.
export function ExamedChapterChips({ status, onSelect, onRetry }) {
  if (!status || status.loading) {
    return (
      <div className="ui-exam-chips" aria-busy="true">
        <Skeleton width={56} height={24} radius="full" />
        <Skeleton width={56} height={24} radius="full" />
        <Skeleton width={56} height={24} radius="full" />
      </div>
    );
  }
  if (status.error) {
    return (
      <div className="ui-exam-inline-error">
        <span>Boblarni yuklab bo'lmadi</span>
        {onRetry && (
          <Button variant="ghost" size="sm" onClick={onRetry}>
            Qayta urinish
          </Button>
        )}
      </div>
    );
  }
  const chapters = sortChapters(status.data);
  if (chapters.length === 0) {
    return <span className="ui-exam-muted">Hali imtihon topshirilmagan</span>;
  }
  return (
    <div className="ui-exam-chips">
      {chapters.map((chapter) => (
        <button
          key={chapter.id}
          type="button"
          className="ui-exam-chip"
          title={chapter.title}
          onClick={() => onSelect && onSelect(chapter)}
        >
          {chapterLabel(chapter)}
        </button>
      ))}
    </div>
  );
}

// last-exam-result xulosasi: O'tgan / O'tmagan va urinishlar soni.
export function LastExamSummary({ status, onRetry }) {
  if (!status || status.loading) {
    return (
      <div className="ui-exam-summary" aria-busy="true">
        <Skeleton width={72} height={20} radius="full" />
        <Skeleton width={88} height={14} radius="sm" />
      </div>
    );
  }
  if (status.error) {
    return (
      <div className="ui-exam-inline-error">
        <span>Natijani yuklab bo'lmadi</span>
        {onRetry && (
          <Button variant="ghost" size="sm" onClick={onRetry}>
            Qayta urinish
          </Button>
        )}
      </div>
    );
  }
  const data = status.data;
  if (!data) return null;
  if (!data.number_of_attempts) {
    return (
      <div className="ui-exam-summary">
        <Badge variant="neutral" size="sm">Topshirilmagan</Badge>
      </div>
    );
  }
  return (
    <div className="ui-exam-summary">
      <Badge variant={data.passed ? 'success' : 'danger'} size="sm" dot>
        {data.passed ? "O'tgan" : "O'tmagan"}
      </Badge>
      <span className="ui-exam-muted">Urinishlar: {data.number_of_attempts}</span>
    </div>
  );
}

// Urinishni tanlash: "1-urinish", "2-urinish"... (massiv tartibida). Bitta urinish bo'lsa ko'rsatilmaydi.
export function AttemptSwitcher({ attempts, value, onChange }) {
  if (!attempts || attempts.length <= 1) return null;
  return (
    <SegmentedControl
      aria-label="Urinish"
      size="sm"
      options={attempts.map((attempt, index) => ({ value: index, label: `${attempt.number}-urinish` }))}
      value={value}
      onChange={onChange}
    />
  );
}
